var url = process.env.NODE_ENV === 'development' ? "http://localhost:2000/" : "https://globe13.in/api/"

export const BASE_URL = url;
export const SEND_OTP_URL = "auth/send-otp";
export const VERIFY_OTP_URL = "auth/verify-otp";
